export function getInitialTutorialStepIndex() {
  return 0
}

export function getPreviousTutorialStepIndex(stepIndex) {
  return Math.max(0, stepIndex - 1)
}

export function getNextTutorialStepIndex(stepIndex, totalSteps) {
  if (totalSteps <= 0) {
    return 0
  }

  return Math.min(totalSteps - 1, stepIndex + 1)
}

export function isLastTutorialStep(stepIndex, totalSteps) {
  return totalSteps > 0 && stepIndex >= totalSteps - 1
}
